<template>
  <div :class="`${prefixClass}-time`">
    <div
      v-if="showTimeHeader"
      :class="`${prefixClass}-time-header`">
      <sButton
        :class="`${prefixClass}-time-header-title`"
        type="text"
        @click="handleClickTitle">
        {{ title }}
      </sButton>
    </div>
    <div :class="`${prefixClass}-time-content`">
      <sDateListOptions
        v-if="timePickerOptions"
        :date="innerValue"
        :format="innerForamt"
        :get-classes="getClasses"
        :options="timePickerOptions"
        @select="handleSelect"/>
      <sDateListColumns
        v-else
        :date="innerValue"
        :get-classes="getClasses"
        :hour-options="hourOptions"
        :hour-step="hourStep"
        :minute-options="minuteOptions"
        :minute-step="minuteStep"
        :scroll-duration="scrollDuration"
        :second-options="secondOptions"
        :second-step="secondStep"
        v-bind="ShowHourMinuteSecondAMPM"
        @select="handleSelect"/>
    </div>
  </div>
</template>

<script>
import { format, getValidDate } from 'toolkit/utils/date'
import sDateListColumns from './date-list-columns'
import sDateListOptions from './date-list-options'
import { getLocale } from 'toolkit/components/dateComponents/locale'

export default {
  name: 'sTimePanel',
  components: { sDateListColumns, sDateListOptions },
  inject: {
    /*getLocale: {
      default: () => getLocale,
    },*/
    prefixClass: {
      default: 's-datepicker',
    },
  },
  props: {
    value: {
      type: [Array, Date, String, Number, null],
    },
    defaultValue: {
      type: [Array, Date, String, Number],
      default() {
        const date = new Date()
        date.setHours(0, 0, 0, 0)
        return date
      },
    },
    format: {
      type: String,
      default: 'HH:mm:ss',
    },
    timeTitleFormat: {
      type: String,
      default: 'DD.MM.YYYY',
    },
    showTimeHeader: {
      type: Boolean,
      default: false,
    },
    disabledTime: {
      type: Function,
      default: () => false,
    },
    /**@type {Object|Function} 
    {
        start: '08:30',
        step: '00:30',
        end: '18:30',
        format: 'HH:mm',
      }
    */
    timePickerOptions: {
      type: [Object, Function],
      default() {
        return null
      },
    },
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    hourStep: {
      type: Number,
      default: 1,
    },
    minuteStep: {
      type: Number,
      default: 1,
    },
    secondStep: {
      type: Number,
      default: 1,
    },
    showHour: {
      type: Boolean,
      default: undefined,
    },
    showMinute: {
      type: Boolean,
      default: undefined,
    },
    showSecond: {
      type: Boolean,
      default: undefined,
    },
    use12h: {
      type: Boolean,
      default: undefined,
    },
    scrollDuration: {
      type: Number,
      default: 100,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      innerValue: getValidDate(this.value, this.defaultValue),
    }
  },
  computed: {
    title() {
      const titleFormat = this.timeTitleFormat
      const date = new Date(this.innerValue)
      return this.formatDate(date, titleFormat)
    },
    innerForamt() {
      return typeof this.format === 'string' ? this.format : 'HH:mm:ss'
    },
    ShowHourMinuteSecondAMPM() {
      const fmt = this.innerForamt
      const defaultProps = {
        showHour: /[HhKk]/.test(fmt),
        showMinute: /m/.test(fmt),
        showSecond: /s/.test(fmt),
        use12h: /a/i.test(fmt),
      }
      const obj = {}
      Object.keys(defaultProps).forEach(key => {
        obj[key] = typeof this[key] === 'boolean' ? this[key] : defaultProps[key]
      })
      return obj
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.innerValue = getValidDate(this.value, this.defaultValue)
      },
    },
  },
  methods: {
    formatDate(date, fmt) {
      return format(date, fmt, getLocale(this.$i18n.locale))
    },
    isDisabledTime(value) {
      return this.disabledTime(new Date(value))
    },
    isDisabledHour(date) {
      const value = new Date(date)
      return (
        this.isDisabledTime(value) &&
        this.isDisabledTime(value.setMinutes(0, 0, 0)) &&
        this.isDisabledTime(value.setMinutes(59, 59, 999))
      )
    },
    isDisabledMinute(date) {
      const value = new Date(date)
      return (
        this.isDisabledTime(value) &&
        this.isDisabledTime(value.setSeconds(0, 0)) &&
        this.isDisabledTime(value.setSeconds(59, 999))
      )
    },
    isDisabledAMPM(date) {
      const value = new Date(date)
      const minHour = value.getHours() < 12 ? 0 : 12
      const maxHour = minHour + 11
      return (
        this.isDisabledTime(value) &&
        this.isDisabledTime(value.setHours(minHour, 0, 0, 0)) &&
        this.isDisabledTime(value.setHours(maxHour, 59, 59, 999))
      )
    },
    isDisabled(date, type) {
      if (this.disabled) { return true }
      if (type === 'hour') {
        return this.isDisabledHour(date)
      }
      if (type === 'minute') {
        return this.isDisabledMinute(date)
      }
      if (type === 'ampm') {
        return this.isDisabledAMPM(date)
      }
      return this.isDisabledTime(date)
    },
    handleSelect(value, type) {
      const date = new Date(value)
      if (!this.isDisabled(value, type)) {
        this.innerValue = date
        if (!this.isDisabledTime(date)) {
          this.$emit('select', date, type)
        }
      }
    },
    handleClickTitle() {
      this.$emit('clicktitle')
    },
    getClasses(value, type) {
      const cellDate = new Date(value)
      const classes = []
      if (this.isDisabled(value, type)) {
        classes.push('disabled')
      }
      if (cellDate.getTime() === this.innerValue.getTime()) {
        classes.push('active')
      }
      return classes
    },
  },
}
</script>